import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function AdminProtected({ children }) {
  const location = useLocation();

  const token = localStorage.getItem("admin_token"); // ✅ same key everywhere
  const isAdminLoggedIn = !!token;

  if (!isAdminLoggedIn) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}